import { api } from "../helpers";

export const getList = (param, token) => {
	return api("/instagrams", "GET", undefined, param, token);
};

export const postMany = (payload, token) => {
	return api("/instagrams/many", "POST", payload, undefined, token);
};

export const truncate = (payload, token) => {
	return api("/instagrams/truncate", "DELETE", payload, undefined, token);
};
